import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=2bd247a9&scoped=true"
var script = {}
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=2bd247a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd247a9",
  null
  
)

export default component.exports